import React, { useEffect, useState } from 'react';
import { conf } from '../domain/services/configService';
import { eventService } from '../domain/services/eventService';
import { addScript } from '../domain/utils/domUtils';

const areAllScriptsLoaded = () => 'SDK' in window;

const initialState = {
  sdk: undefined,
  sdkHelper: undefined
};

export const WithVideoSDK = Component => props => {
  const [state, setState] = useState(initialState);

  const onScriptLoad = () => {
    if (areAllScriptsLoaded()) {
      setState({ sdk: window.SDK, sdkHelper: window.SDKHelper });
    }
  };

  const loadScripts = () => {
    addScript(
      `https://player${conf.isStage ? '-stage' : ''}.techops.disn.io/current/build/app.js`,
      { async: false, callback: onScriptLoad }
    );
  };

  const checkForScriptPresence = () => {
    if (areAllScriptsLoaded()) {
      onScriptLoad();
    } else {
      loadScripts();
    }
  };

  useEffect(() => {
    eventService.addEventListener(
      'OneTrustInteractionDone',
      checkForScriptPresence,
      {
        once: true
      }
    );
  }, []);

  return state.sdk ? (
    <Component
      sdk={state.sdk}
      sdkHelper={state.sdkHelper}
      // TODO FIXME remove template after migrating all players
      template={conf.videoPlayerTemplate}
      {...props}
    />
  ) : null;
};
